module.exports = __webpack_public_path__ + "static/img/manual-7.e638c4b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/en/manual-7.png
// module id = 4fs5
// module chunks = 4